import Review1 from './Review1';

export default Review1;
